import React, { useEffect, useMemo, useState } from 'react'
import { ResponseRequest } from 'components/Types/GeneralTypes';
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando';
import PDFViewer from 'components/Varios/PDFViewer';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { DownloadDocument } from 'helpers/files';
import { Button, Col, Row, FormGroup } from 'react-bootstrap';
import { Label } from 'reactstrap';
import { authenticationService } from 'services/authentication.service';
import { ObtenerInformacionHojaVida, ObtenerPdfHojaVida, ObtenerPdfHojaVidaAcreditacionEURACE, ObtenerWordHojaVidaAcreditacionEURACE, ObtenerPdfHojaVidaAcreditacionAACSB, ObtenerPdfHojaVidaAcreditacionABET } from './FunctionsGenerarHojaVida'
import { InformacionHojaVida } from './typesGenerarHojaVida';

import Swal from 'sweetalert2'
import SelectItem2 from '../../Varios/SelectNew';
import WarningSVG from "assets/icons/Permisos/Informativa R.svg"

export default function GenerarHojaVida() {
    const [urlHojaVida, seturlHojaVida] = useState<string>("")
    const [loading, setloading] = useState<boolean>(false)
    const [datosHojaVida, setdatosHojaVida] = useState<InformacionHojaVida | undefined>(undefined)
    const [loadingDatos, setloadingDatos] = useState<boolean>(false)
    const [tipoHojaVida, setTipoHojaVida] = useState("");

    const opciones_hojavida = [
        { key: "ESPOL", value: "ESPOL (Se generará una Hoja de Vida con fecha de elaboración de hoy)" },
        { key: "EURACE", value: "EUR-ACE" },
        { key: "EURACE_WORD", value: "EUR-ACE (word)" },
        { key: "AACSB_ES", value: "ACBSP - español" },
        { key: "AACSB_EN", value: "ACBSP - inglés" },
        { key: "ABET", value: "ABET" },
    ];

    function handleErrorInformacion() {
        alertService.error("Ha ocurrido un inconveniente al tratar de Obtener información sobre la última Hoja de Vida");
    }

    async function GetInfoLastHojaVida() {
        setloadingDatos(true)
        var datos = await ObtenerInformacionHojaVida(handleErrorInformacion)
        setdatosHojaVida(datos);
        setloadingDatos(false)
    }

    const ViewerHojaDeVida = useMemo(() => {
        if (loading) {
            return <Cargando mensaje='Generando Hoja de Vida' />
        }
        if (urlHojaVida) {
            return (
                <Row>
                    <Col xl={8} md={10} sm={12}>
                        <PDFViewer url={urlHojaVida} heightValue={"700px"} />
                    </Col>
                </Row>

            )
        }
        else {
            return undefined
        }
    }, [urlHojaVida, loading])

    const MensajeHojaDeVida = useMemo(() => {
        if (loadingDatos && !datosHojaVida) {
            return (<Cargando />)
        }
        else if (datosHojaVida) {
            return (
                <div style={{ display: "flex" }}>
                    <span>La última Hoja de Vida fue generada en {ObtenerFechaFromIsoFormat(datosHojaVida.ultimaFechaGeneracion)}</span>
                    <span className="ml-2"><i className="fas fa-download download "
                        onClick={() => { DownloadDocument(datosHojaVida.referencia, authenticationService.currentUserValue.token) }}></i></span>
                </div>
            )
        }

        else {
            return (
                <div style={{ display: "flex" }}>
                    <span>No tiene una Hoja de Vida generada</span>
                </div>
            )
        }
    }, [datosHojaVida, loadingDatos])

    const GenerarHojaVida = async () => {
        var error = "";

        if (!tipoHojaVida) error += "Seleccione un tipo de hoja de vida. <br />";

        if (error !== "") {
            Swal.fire({
                html: error,
                imageUrl: `${WarningSVG}`,
                imageHeight: 100,
                imageAlt: "Anuncio",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#243165",
            });
            return;
        }

        alertService.clear();
        setloading(true);

        try {
            let resultado: ResponseRequest | undefined;

            switch (tipoHojaVida) {
                case "ESPOL":
                    resultado = await ObtenerPdfHojaVida();
                    break;
                case "EURACE":
                    resultado = await ObtenerPdfHojaVidaAcreditacionEURACE();
                    break;
                case "EURACE_WORD":
                    resultado = await ObtenerWordHojaVidaAcreditacionEURACE();
                    break;
                case "AACSB_ES":
                    resultado = await ObtenerPdfHojaVidaAcreditacionAACSB("ES");
                    break;
                case "AACSB_EN":
                    resultado = await ObtenerPdfHojaVidaAcreditacionAACSB("EN");
                    break;
                case "ABET":
                    resultado = await ObtenerPdfHojaVidaAcreditacionABET("ES");
                    break;
            }

            if (resultado?.status === 200) {
                seturlHojaVida(resultado.dataResponse);
                alertService.success("Se ha generado la hoja de vida con éxito.");
            } else {
                alertService.error(resultado?.errorMessage ?? "Error inesperado.");
            }

        } finally {
            setloading(false);
        }
    };

    useEffect(() => {
        GetInfoLastHojaVida();
    }, [])

    return (
        <div className="content">
            <div className='titulo_seccion'>Generar Hoja de Vida</div>
            <Row>
                <Col md={6}>
                    <FormGroup className="mb-3">
            {
                MensajeHojaDeVida
            }
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <FormGroup className="mb-3">
                        <Label for="tipoHojaVida">Tipo de Hoja de Vida*</Label>
                        <SelectItem2
                            options={opciones_hojavida.map((op) => ({
                                value: op.key,
                                label: op.value,
                            }))}
                            placeholder="-- Seleccione una opción --"
                            name="tipoHojaVida"
                            id="tipoHojaVida"
                            icon="fa-caret-down"
                            value={tipoHojaVida}
                            onChange={(selectedOption: any) => setTipoHojaVida(selectedOption)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Button
                        color="primary"
                        className="mt-3"
                        disabled={loading}
                        onClick={GenerarHojaVida}
                    >
                        Generar Hoja de Vida
                    </Button>
                </Col>
            </Row>

            {
                ViewerHojaDeVida
            }

        </div>
    )
}